"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const breakpoints = {
    base: '0px',
    '2xs': '320px',
    xs: '375px',
    sm: '425px',
    md: '786px',
    lg: '1024px',
    xl: '1440px',
    '2xl': '2560px',
};
exports.default = breakpoints;
